module.exports = __webpack_public_path__ + "static/img/login.d0b323f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/login.png
// module id = PHrC
// module chunks = 104